export function removeDuplicate<T>(array: Array<T>): Array<T> {
  return array.filter((el, i, a) => i === a.indexOf(el));
}

export function validateEmail(email: string): boolean {
  return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email);
}